var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlarmIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F16153",
    d: "M31.78 23.75L21.973 8.344c-1.527-2.398-5.148-2.398-6.675 0L5.491 23.75c-1.596 2.51.28 5.736 3.338 5.736h19.613c3.058-.004 4.934-3.227 3.338-5.736zm-13.144 2.271c-.506 0-.99-.201-1.348-.56-.358-.358-.558-.845-.558-1.352 0-.507.2-.993.558-1.352.357-.358.842-.56 1.348-.56.505 0 .99.202 1.347.56.358.359.558.845.558 1.352 0 .507-.2.994-.558 1.352-.357.359-.842.56-1.347.56zm1.905-7.416c0 .507-.2.994-.558 1.352-.357.359-.842.56-1.347.56-.506 0-.99-.201-1.348-.56-.358-.358-.558-.845-.558-1.352V12.56c0-.507.2-.993.558-1.352.357-.359.842-.56 1.348-.56.505 0 .99.201 1.347.56.358.359.558.845.558 1.352v6.046z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmIcon);
export default ForwardRef;